import script from "./RicetteTable1.vue?vue&type=script&setup=true&lang=js"
export * from "./RicetteTable1.vue?vue&type=script&setup=true&lang=js"

import "./RicetteTable1.vue?vue&type=style&index=0&id=cdf94504&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdf94504"]])

export default __exports__